
export const BarColors = {
	marker: '#213033',
	line: 'rgba(0,0,0,0.2)',
	white: '#FFF',
	green: '#98C5A2',
	yellow: '#F8E3A0',
	red: '#F79C8D',
	lightGreen: '#CCEDD6',
};
// Intentionally hardcoded colors because there is not a good
// way to import values from variables.scss file to this .ts file
